module.exports = __webpack_public_path__ + "img/notification.f32d53fc.svg";